/* eslint-disable dot-notation */
import SettingsApi from '@/services/admin/SettingsApi';
import { Setting } from '../types/identity';
import { defineStore } from 'pinia';
import { i18n } from '@/plugins/i18n';
import { showApiErrorSnackbar, createErrorMessage } from '@/util/snackBarUtil';

interface State {
  settings: Setting[];
  settingsObject: Record<string, any>;
}

export const systemSettingStore = defineStore('systemSettingStore', {
  state: (): State => ({
    settings: [],
    settingsObject: {}
  }),
  getters: {
    getHostname: (state: State): string => state.settingsObject['INVENTORY_CONNECTION_PROFILE_HOSTNAME'] as string ?? '',
    isClientCertCa: (state: State) => (uuid: string): boolean => {
      const deviceControlSetting = state.settingsObject['DEVICECONTROL_CLIENT_CERT_CA_ID'] as string ?? '';
      const autoUpdateSetting = state.settingsObject['AUTOUPDATE_CLIENT_CERT_CA_ID'] as string ?? '';
      return (
        deviceControlSetting === uuid ||
        autoUpdateSetting === uuid
      );
    },
    isServerCertificate: (state: State) => (uuid: string): boolean => {
      const autoUpdateServerCertIdPref = state.settingsObject['AUTOUPDATE_SERVER_CERT_ID'] as string ?? '' ;
      const deviceControlServerCertIdPref = state.settingsObject['DEVICECONTROL_SERVER_CERT_ID'] as string ?? '';
      return (
        autoUpdateServerCertIdPref === uuid ||
        deviceControlServerCertIdPref === uuid
      );
    }
  },
  actions: {
    async fetchSettings() {
      try {
        const response = await SettingsApi.find();
        this.updateSettingsArray(response.data);
      } catch (error) {
        showApiErrorSnackbar(createErrorMessage(i18n.t('errors.fetchSystemSettings')), error);
        throw error;
      }
    },
    async updateSettings(data: Record<string, unknown>) {
      try {
        const response = await SettingsApi.updateSettings(data);
        this.updateSettingsArray(response.data);
      } catch (error) {
        showApiErrorSnackbar(createErrorMessage(error), error);
      }
    },
    updateSettingsArray(settingsObject: Record<string, unknown>) {
      this.settingsObject = settingsObject;
      this.settings = Object.entries(settingsObject).map(([key, value]) => ({
        name: key,
        value: value
      }));
    }
  }
});
